import type { FunctionComponent } from "react"

import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { useLocale } from "@/modules/locales/useLocale"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

import { List } from "./List"

export const LocaleSelector: FunctionComponent = () => {
  const locale = useLocale()
  const { dataCareerCenter } = useCareerCenterFetch()
  const { dataCurrentUser } = useCurrentUserFetch()
  const locales = dataCareerCenter?.careerCenterConf?.locales || []

  const localesToDisplay =
    !!dataCurrentUser?.isLogged && dataCurrentUser?.attributes.locales ? dataCurrentUser?.attributes.locales : locales

  if (!localesToDisplay.length) return null

  return <List locale={locale} localesToDisplay={localesToDisplay} />
}
